import { render, staticRenderFns } from "./monitorModal.vue?vue&type=template&id=1ddafc37"
import script from "./monitorModal.vue?vue&type=script&lang=js"
export * from "./monitorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports